import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { tile, body as bodyClass } from "./tile.module.scss";

const Tile = ({ className, body, ...props }) => (
  <section
    className={classNames(tile, { [bodyClass]: body }, className)}
    {...props}
  />
);

Tile.propTypes = {
  className: PropTypes.string,
  /**
   * A boolean to specify if this tile is body-only (i.e. Without a TileHeader).  Use to simply markup and to skip wrapping body content in a TileBody.
   */
  body: PropTypes.bool
};

Tile.defaultProps = {
  className: "",
  body: false
};

export default Tile;
